import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  type AutoAwardRuleKey,
  type UpdateAutoAwardRuleBody,
  attendanceAwardsApi,
} from '@/services/api/attendance-awards/attendance-awards';

export const attendanceAwardsKeys = {
  rules: ['admin', 'sand-dollars', 'attendance-awards', 'rules'] as const,
};

const invalidateAll = (qc: ReturnType<typeof useQueryClient>) => {
  qc.invalidateQueries({ queryKey: ['admin', 'sand-dollars'] });
  qc.invalidateQueries({ queryKey: attendanceAwardsKeys.rules });
};

export function useAutoAwardRulesQuery() {
  return useQuery({
    queryKey: attendanceAwardsKeys.rules,
    queryFn: () => attendanceAwardsApi.listRules(),
  });
}

export function useUpdateAutoAwardRuleMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ruleKey, body }: { ruleKey: AutoAwardRuleKey; body: UpdateAutoAwardRuleBody }) =>
      attendanceAwardsApi.updateRule(ruleKey, body),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useRunAutoAwardMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { ruleKey: AutoAwardRuleKey; date: string }) => attendanceAwardsApi.run(body),
    onSuccess: () => invalidateAll(qc),
  });
}
